import {useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Alerts, OtpInput} from '../../../components'
import {useHistory, useLocation} from 'react-router-dom'
import {createPinCode, enableAuthenticatorPost, loginCmsStep2} from '../apis'
import {useDispatch} from 'react-redux'
import * as component from '../../../components/redux/componentRedux'
import * as auth from '../redux/AuthRedux'
import {messageError} from '../../../utils'
import jwt_decode from 'jwt-decode'
import {saveDataLocalStorage, setUserInfo} from '../helpers'
import Cookies from 'js-cookie'

interface Props {
  type: string
  userId?: string
}

export function CreatePinCode({type, userId}: Props) {
  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false)
  let history = useHistory()
  const dispatch = useDispatch()
  let location: any = useLocation()
  let email = location.state?.email
  let sessionId = location.state?.sessionId
  let userIdURL = location.state?.userId
  let authenType = location.state?.authenType

  const onChange = (value: string) => setOtp(value)

  const handleSubmit = () => {
    setLoading(true)
    if (!authenType) {
      if (type == '2' || type == 'PinCode' || email) {
        let data = {
          model: {
            code: otp,
            userId: '',
            email: '',
          },
        }
        if (email) data.model.email = email
        if (userId) data.model.userId = userId
        createPinCode(data)
          .then((res: any) => {
            if (res && !res.isError) {
              setLoading(false)
              dispatch(
                component.actions.writeAlert({
                  show: true,
                  type: 'success',
                  message: 'Tạo mã pin thành công. Bạn sẽ quay lại trang đăng nhập sau giây lát.',
                })
              )
              setTimeout(() => {
                window.location.href = '/auth/login'
              }, 2000)
            }
          })
          .catch((error) => {
            setLoading(false)
            dispatch(
              component.actions.writeAlert({
                show: true,
                type: 'error',
                message: messageError(error.response),
              })
            )
          })
      }
      if (type == 'GoogleAuthenticator' || type == '1') {
        if (!otp) {
          dispatch(
            component.actions.writeAlert({
              show: true,
              type: 'warning',
              message: 'Nhập Otp.',
            })
          )
          return
        }
        let data = {
          model: {
            userId: userId ? userId : '',
            code: otp,
            sharedKey: '',
            authenticatorUri: true,
          },
        }
        dispatch(component.actions.showBackdrop({show: true}))
        enableAuthenticatorPost(data)
          .then((res: any) => {
            if (res && !res.isError) {
              dispatch(component.actions.showBackdrop({show: false}))
              window.location.href = '/auth/login'
            }
          })
          .catch((error) => {
            setLoading(false)
            dispatch(component.actions.showBackdrop({show: false}))
            dispatch(
              component.actions.writeAlert({
                show: true,
                type: 'error',
                message: messageError(error.response),
              })
            )
          })
      }
    }
    if (authenType) {
      let data = {
        model: {
          userId: userIdURL,
          sesssionId: sessionId,
          authenticationType: authenType,
          code: otp,
          remember: false,
          applicationType: 2,
        },
      }
      loginCmsStep2(data)
        .then((res: any) => {
          if (res && !res.isError) {
            let decode: any = jwt_decode(res.data.accessToken)
            let token = {
              userId: res.data.userId,
              userName: decode?.email,
              phone: res.data.phoneNumber,
              fullName: decode?.name,
              companyName: res.data.companyName,
              companyId: res.data.companyId,
              companyCode: decode?.company_code,
              divisionName: res.data.divisionName,
              divisionCode: res.data?.division_code,
              divisionId: res.data?.DivisionId,
              accessToken: res.data.accessToken,
              refreshToken: res.data.refreshToken,
              sessionId: res.data.sessionId,
            }
            let date = new Date()
            date.setTime(date.getTime() + 2 * 60 * 60 * 1000)
            Cookies.set('SessionId', sessionId, {expires: date, sameSite: 'strict'})
            setLoading(false)
            setUserInfo(JSON.stringify(token))
            dispatch(auth.actions.login(token))
            saveDataLocalStorage(res)
          }
        })
        .catch((error) => {
          dispatch(
            component.actions.writeAlert({
              show: true,
              type: 'error',
              message: messageError(error.response),
            })
          )
        })
    }
  }

  const handleGoPrev = () => {
    history.goBack()
  }

  return (
    <>
      <Alerts />
      <a href='/' className='mb-4' style={{display: 'flex', justifyContent: 'center'}}>
        <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-tmiv.png')} className='h-80px mb-5' />
      </a>
      <div className='text-center mb-8'>
        <h1 className='text-dark mb-3'>Mã Pin</h1>
      </div>
      {(type == '2' || type == 'PinCode') && (
        <p style={{fontStyle: 'italic', color: 'red', fontSize: '15px'}}>Nhập mã PIN của bạn</p>
      )}
      {(type == '3' || type == 'Email') && (
        <p style={{fontStyle: 'italic', color: 'red', fontSize: '15px'}}>
          Nhập mã PIN được gửi tới Email của bạn
        </p>
      )}
      <OtpInput value={otp} valueLength={6} onChange={onChange} />
      <div className='d-flex flex-wrap justify-content-center pb-lg-0 mt-8'>
        <button onClick={handleSubmit} className='btn btn-lg btn-primary fw-bolder me-4'>
          <span className='indicator-label'>Hoàn thành</span>
          {loading && (
            <span className='indicator-progress'>
              Vui lòng đợi...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <button
          id='kt_login_password_reset_form_cancel_button'
          className='btn btn-lg btn-light-primary fw-bolder'
          onClick={handleGoPrev}
        >
          Quay lại
        </button>
      </div>
    </>
  )
}
